export function getBaseUrl (retailer, isV2Api) {
    switch (process.env.REACT_APP_ENV) {
    case 'prod':
        return `https://${retailer}/ice.dpn.inmar.com/v2`;

    // Dev & Stage
    default:
        return `https://${retailer}.ice.test.dpn.inmar.com/${isV2Api ? 'v2' : 'v3'}`;
    }
}